import { all, call, fork, take, takeEvery, put, select } from 'redux-saga/effects'

import {
  validateSession,
  getUserDataFromLocalStorage,
  getUserDefaultPreferences,
  getUserBrokerData,
  getDeductiblesData
} from '../../lib/authentication'

import * as selectors from './selectors'
import * as actions from './actions'

import { initPerson, unsetPerson } from '../person/actions'
import { initUser, unsetUser } from '../user/actions'
import { setLoggedUser, unsetLoggedUser } from '../underwriter/actions'
import { initDeductibles, unsetDeductibles } from '../deductibles/actions'

export const getUser = (id) => {
  return apigClient.adminUsersIdGet({ id }, {}, {});
};

export function* modifyUser(originalUser) {
  const { id, brokerId } = originalUser;
  const [defaultPreference, brokerage, NYdeductibles] = yield all([
    call(getUserDefaultPreferences, id),
    call(getUserBrokerData, brokerId),
    call(getDeductiblesData, 'NY')
  ])

  const type = yield select(selectors.getUserType)
  const isUnderwriter = yield select(selectors.isUnderwriter)
  const user = { ...originalUser, type, ...defaultPreference, ...brokerage }
  const person = { id, brokerId, isUnderwriter }
  const deductibles = { id: 'NY', zipcodes: NYdeductibles }

  yield put(initUser(user))
  yield put(initPerson(person))
  yield put(setLoggedUser(user))
  yield put(initDeductibles(deductibles));
}

export function* setAuth() {
  const user = yield call(getUserDataFromLocalStorage)

  yield put(actions.setUser(user))
  yield call(modifyUser, user)
  yield put(actions.setAuthenticated(true))
}

export function* unsetAuth() {
  yield put(unsetUser())
  yield put(unsetPerson())
  yield put(unsetLoggedUser())
  yield put(actions.setAuthenticated(false))
  yield put(unsetDeductibles())
}

function fetchContactUnderWriters() {
  return fetch('../../data/underwriters.json')
  .then(response => response.json())
  .catch((error) => { throw error })
}

export function* getContactUnderwriters() {
  try {
    const data = yield call(fetchContactUnderWriters);

    yield put(actions.setContactUnderWriter(data))
  } catch (e) {
    yield put(actions.resetContactUnderWriter())
  }
}

export function* initAuth() {
  yield put(actions.setLoading(true))
  yield put(actions.setAuthenticated(false))
  yield getContactUnderwriters()

  const user = yield call(getUserDataFromLocalStorage)
  yield put(actions.setUser(user))

  const { idToken, status } = yield call(validateSession)

  // Checking for 'MFA_REQUIRED' covers us for Okta users that have 2FA enabled
  if (idToken && ['ACTIVE', 'MFA_REQUIRED'].includes(status)) {
    yield call(setAuth)
  } else {
    yield call(unsetAuth)
  }

  yield put(actions.setLoading(false))
}

export const sagas = function* authSagas() {
  yield takeEvery(actions.INIT_CONTACT_UNDERWRITERS, getContactUnderwriters)
  yield takeEvery(actions.INIT_AUTH, initAuth)
  yield takeEvery(actions.SET_AUTH, setAuth)
  yield takeEvery(actions.UNSET_AUTH, unsetAuth)
}
